import React, { useMemo } from 'react';
import styled from '@emotion/styled';

import { GeneralPagebackIcon as PageBack } from '@common/icons';
import { Typography } from '@common/styles';

export enum TitledHeadType {
  ANOTHER_OPTIONS = 'ANOTHER_OPTIONS',
  EXCHANGE = 'EXCHANGE',
  SHIPPING_DETAIL = 'SHIPPING_DETAIL',
  RESTOCK_NOTIFICATION = 'RESTOCK_NOTIFICATION',
}
interface Props {
  title?: string;
  type: TitledHeadType;
  onClickBack?: () => void;
}
export const TitledHead = ({ title, type, onClickBack = () => undefined }: Props) => {
  const titleByType = useMemo(() => {
    switch (type) {
      case TitledHeadType.ANOTHER_OPTIONS:
        return '옵션 선택';
      case TitledHeadType.EXCHANGE:
        return '교환 옵션';
      case TitledHeadType.SHIPPING_DETAIL:
        return '배송 정보';
      case TitledHeadType.RESTOCK_NOTIFICATION:
        return '알림받을 옵션 선택';
      default:
        return '';
    }
  }, [type]);

  return (
    <Container>
      {type !== TitledHeadType.EXCHANGE && <BackButton onClick={onClickBack} />}
      <span className={Typography.BODY_17_BOLD}>{title || titleByType}</span>
    </Container>
  );
};

const Container = styled.div`
  margin-top: 16px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 44px;
`;

const BackButton = styled(PageBack)`
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
`;
